import React, { useMemo } from 'react';
import { Col, Form, Input, Row, Select } from 'antd';
import type { Rule } from 'antd/es/form';
import areaCode from '@/assets/json/areaCode.json';

const { Item } = Form;

interface PhoneFieldProps {
  label: React.ReactNode;
  required?: boolean;
  formItemClassName?: string;
  selectClassName?: string;
  inputClassName?: string;
  areaCodeName: string;
  phoneName: string;
  phoneRules?: Rule[];
  phonePlaceholder?: string;
  inputMaxLength?: number;
  showCount?: boolean;
  areaSpan?: number;
  phoneSpan?: number;
}

const PhoneField: React.FC<PhoneFieldProps> = ({
  label,
  required = false,
  formItemClassName,
  selectClassName,
  inputClassName,
  areaCodeName,
  phoneName,
  phoneRules,
  phonePlaceholder,
  inputMaxLength = 50,
  showCount = false,
  areaSpan = 8,
  phoneSpan = 16,
}) => {
  const uniqueAreaCode = useMemo(() => {
    const seen = new Set<string>();
    return areaCode.filter((item: any) => {
      if (seen.has(item.value)) {
        return false;
      }
      seen.add(item.value);
      return true;
    });
  }, []);

  const sortedAreaCode = useMemo(
    () =>
      [...uniqueAreaCode].sort((a: any, b: any) => {
        const numA = parseInt(a.value.replace('+', ''), 10);
        const numB = parseInt(b.value.replace('+', ''), 10);
        return numA - numB;
      }),
    [uniqueAreaCode],
  );

  return (
    <Item label={label} required={required} className={formItemClassName}>
      <Row gutter={12} wrap={false}>
        <Col span={areaSpan}>
          <Item noStyle name={areaCodeName}>
            <Select
              placeholder="区号"
              className={selectClassName}
              showSearch
              filterOption={(input, option: any) => {
                const item = areaCode.find((code: any) => code.value === option?.value);
                if (!item) {
                  return false;
                }
                return item.value.toLowerCase().includes(input.toLowerCase());
              }}
            >
              {sortedAreaCode.map((item: any, index: number) => (
                <Select.Option key={`${item.value}-${index}`} value={item.value}>
                  {item.value}
                </Select.Option>
              ))}
            </Select>
          </Item>
        </Col>
        <Col span={phoneSpan}>
          <Item dependencies={[areaCodeName]} noStyle name={phoneName} rules={phoneRules}>
            <Input
              maxLength={inputMaxLength}
              placeholder={phonePlaceholder}
              className={inputClassName}
              showCount={showCount}
            />
          </Item>
        </Col>
      </Row>
    </Item>
  );
};

export default PhoneField;
